import React, {useMemo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {Tooltip, Chip} from '@material-ui/core';
import {isFunction} from '@ozgene/gp5.utils.object-functions';
import {formatDateShort} from '@ozgene/gp5.utils.date-functions';

function ContextualDateFormatter(props) {
  const {
    value,
    row,
    column: {
      contextualDateIcon,
      contextualDateColor,
      contextualDateClassName,
      contextualDateTooltip,
    },
  } = props;
  const getIfFunction = useCallback(
    (val) => (isFunction(val) ? val(row) : val),
    [row],
  );
  const formattedValue = formatDateShort(value)
  const text = formattedValue === 'Invalid Date' ? value : formattedValue
  const tooltip = useMemo(
    () => (contextualDateTooltip ? getIfFunction(contextualDateTooltip) : text),
    [text, contextualDateTooltip, getIfFunction],
  );
  const icon = useMemo(
    () => getIfFunction(contextualDateIcon),
    [contextualDateIcon, getIfFunction],
  );
  const color = useMemo(
    () => getIfFunction(contextualDateColor),
    [contextualDateColor, getIfFunction],
  );
  const className = useMemo(
    () => getIfFunction(contextualDateClassName),
    [contextualDateClassName, getIfFunction],
  );

  return (
    value && (
      <Tooltip title={tooltip || text}>
        <Chip
          className={className}
          icon={icon}
          variant="outlined"
          label={text}
          color={color}
          size="small"
        />
      </Tooltip>
    )
  );
}

ContextualDateFormatter.propTypes = {
  value: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  row: PropTypes.object.isRequired,
  column: PropTypes.shape({
    contextualDateIcon: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.func,
    ]),
    contextualDateColor: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
    ]),
    contextualDateClassName: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
    ]),
    contextualDateTooltip: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
    ]),
  }).isRequired,
};

export default ContextualDateFormatter;
